import React from 'react';
import { MapContainer, Marker, Popup, TileLayer } from 'react-leaflet';
import { TrialLocationView } from '@data/sdk/match';

const CENTER = {
  lat: 0.0,
  long: 0.0,
};

type MapProps = {
  locations: TrialLocationView[];
};
export const Map = ({ locations }: MapProps) => {
  return (
    <MapContainer
      attributionControl={false}
      center={[CENTER.lat, CENTER.long]}
      zoom={1}
      className="w-full h-72 rounded-lg"
      worldCopyJump
    >
      <TileLayer attribution="CureWiki" url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
      {locations.map(
        ({ coordinates, id, city, country, facility, zip }) =>
          coordinates && (
            <Marker key={id} position={[coordinates.lat, coordinates.long]}>
              <Popup>
                {facility}, {city}, {country}, {zip}
              </Popup>
            </Marker>
          ),
      )}
    </MapContainer>
  );
};
